import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';

const LoadingContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  
  .spinner {
    width: clamp(2rem, 3vw, 3.125rem);
    height: clamp(2rem, 3vw, 3.125rem);
    border: clamp(0.125rem, 0.25vw, 0.25rem) solid rgba(255, 255, 255, 0.3);
    border-top: clamp(0.125rem, 0.25vw, 0.25rem) solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  /* Responsive sizing for different desktop resolutions */
  @media (min-width: 1920px) {
    .spinner {
      width: 3.125rem;
      height: 3.125rem;
      border: 0.25rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.25rem solid white;
    }
  }

  @media (min-width: 1440px) and (max-width: 1919px) {
    .spinner {
      width: 3rem;
      height: 3rem;
      border: 0.21875rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.21875rem solid white;
    }
  }

  @media (min-width: 1366px) and (max-width: 1439px) {
    .spinner {
      width: 2.8125rem;
      height: 2.8125rem;
      border: 0.21875rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.21875rem solid white;
    }
  }

  @media (min-width: 1280px) and (max-width: 1365px) {
    .spinner {
      width: 2.625rem;
      height: 2.625rem;
      border: 0.1875rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.1875rem solid white;
    }
  }

  @media (min-width: 1024px) and (max-width: 1279px) {
    .spinner {
      width: 2.5rem;
      height: 2.5rem;
      border: 0.1875rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.1875rem solid white;
    }
  }
  
  @media (max-width: 1023px) {
    .spinner {
      width: 2.1875rem;
      height: 2.1875rem;
      border: 0.15625rem solid rgba(255, 255, 255, 0.3);
      border-top: 0.15625rem solid white;
    }
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <LoadingContainer>
        <div className="spinner"></div>
      </LoadingContainer>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
};

export default ProtectedRoute; 